import axios from 'axios';

export async function getDisasterMessages() {
  const response = await axios.get(
    `${window.ApiBaseUrl}/OEMProgramsCommon/GetDisasterMessage?accountId=${window.accountId}&themeName=${window.themeName}&pageControlName=${window.pageControlName}`
  );
  return response.data;
}
